import React from 'react';
import { Box } from 'edenred-ui';
import { withTranslation } from 'react-i18next';

import { FormFields } from '@epi-forms/helpers';
import {
  AddressField,
  CityField,
  CompanyNameField,
  CountryField,
  ZipCodeField
} from '@epi-forms/controls';
import { AddressProps } from '@epi-models/forms/Address';

import { arrayIncludesField } from '../../helpers/ArrayHelper';

function Address({ withCountry, disabled }: AddressProps) {
  return (
    <Box display="flex" gap={5}>
      <Box flex={1}>
        <Box mb={2}>
          <CompanyNameField
            name={FormFields.DeliveryCompanyName}
            readOnly={disabled}
          />
        </Box>
        <Box display="flex" gap={5}>
          <Box flex={1}>
            <ZipCodeField
              name={FormFields.DeliveryZipCode}
              readOnly={disabled}
            />
          </Box>
          <Box flex={2}>
            <CityField name={FormFields.DeliveryCity} readOnly={disabled} />
          </Box>
        </Box>
      </Box>
      <Box flex={1}>
        <Box mb={2}>
          <AddressField name={FormFields.DeliveryAddress} readOnly={disabled} />
        </Box>
        {withCountry && (
          <Box>
            <CountryField
              name={FormFields.DeliveryCountry}
              readOnly={disabled || arrayIncludesField(disabled, 'country')}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

const AddressWithI18n = withTranslation()(Address);

export { AddressWithI18n as Address };
